<template>
  <div class="home-page">
    <div class="header-wrapper">
      <div class="header-bg">
        <div class="header-overlay">
          <h1>DETALIILE CONTEAZĂ ȘI ÎNTOTDEAUNA FAC DIFERENȚA!</h1>

          <!-- 🔽 Buton WhatsApp identic cu Navbar -->
          <a class="cta-btn" href="#" @click.prevent="showWhatsappForm = true">
            FĂ O PROGRAMARE
          </a>

          <!-- 🔽 Formular WhatsApp -->
          <transition name="fade">
            <div
              v-if="showWhatsappForm"
              class="whatsapp-form-overlay"
              @click.self="showWhatsappForm = false"
            >
              <div class="whatsapp-form">
                <h3>Programează o vizită prin WhatsApp</h3>
                <label>
                  Nume:
                  <input
                    v-model="form.name"
                    type="text"
                    placeholder="Ex: Andrei Pop"
                  />
                </label>
                <label>
                  Telefon:
                  <input
                    v-model="form.phone"
                    type="text"
                    placeholder="07xx xxx xxx"
                  />
                </label>
                <label>
                  Serviciu dorit:
                  <input
                    v-model="form.service"
                    type="text"
                    placeholder="Ex: Detailing interior"
                  />
                </label>
                <label>
                  Alte detalii:
                  <textarea
                    v-model="form.details"
                    placeholder="Ex: data preferată, mașina, observații..."
                  ></textarea>
                </label>

                <div class="form-buttons">
                  <button @click="sendWhatsappMessage">
                    Trimite pe WhatsApp
                  </button>
                  <button class="cancel" @click="showWhatsappForm = false">
                    Anulează
                  </button>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <section class="about-home">
      <div class="about-container">
        <h2>BINE AI VENIT LA <span>AUTO HEAVEN DETAILING</span></h2>

        <p>
          Experiența noastră în domeniul auto depășește <strong>5 ani</strong>,
          timp în care am acumulat cunoștințele și abilitățile necesare pentru a
          oferi <strong>servicii de top</strong>.
        </p>

        <p class="final">
          Te așteptăm la <strong>Auto Heaven</strong> – locul unde
          <em>detaliile fac diferența</em> și viitorul e plin de posibilități!
        </p>
        <router-link to="/despre-noi" class="btn-about">
          AFLĂ MAI MULTE
        </router-link>
      </div>
    </section>

    <section class="gallery-intro">
      <h2>Servicii</h2>

      <div class="service-grid">
        <div
          class="service-card"
          v-for="(serviciu, index) in servicii"
          :key="index"
        >
          <router-link
            class="service-bg"
            :to="serviciu.link"
            :style="{
              backgroundImage: `url(${
                serviciu.isFading ? serviciu.nextImage : serviciu.imagine
              })`,
            }"
            :class="{ fading: serviciu.isFading }"
          >
            <div class="overlay">
              <h3>{{ serviciu.titlu }}</h3>
              <p>{{ serviciu.descriere }}</p>
              <span class="btn-serviciu">DETALII</span>
            </div>
          </router-link>
        </div>
      </div>
    </section>

    <section class="reviews-section">
      <GoogleCarousel />
    </section>
  </div>
</template>

<script>
import GoogleCarousel from "@/components/GoogleCarousel.vue";
import fallbackImg from "@/assets/logo.jpg";

export default {
  name: "Home",
  components: { GoogleCarousel },
  data() {
    return {
      servicii: [],
      showWhatsappForm: false,
      whatsappNumber: "40773383914",
      form: {
        name: "",
        phone: "",
        service: "",
        details: "",
      },
      intervalId: null,
    };
  },

  methods: {
    sendWhatsappMessage() {
      const { name, phone, service, details } = this.form;
      const fixedPhone =
        phone.startsWith("0") && phone.length > 1
          ? `0\u200B${phone.slice(1)}`
          : phone;

      const message = `
Salut!
Aș dori să programez o vizită la *AutoHeaven*.

*Detalii client:*
• Nume: ${name || "-"}
• Număr de telefon: ${fixedPhone || "-"}
• Serviciul dorit: ${service || "-"}
• Alte detalii: ${details || "-"}

Vă rog să mă contactați pentru confirmare.
`;
      const url = `https://wa.me/${
        this.whatsappNumber
      }?text=${encodeURIComponent(message)}`;
      window.open(url, "_blank");
      this.showWhatsappForm = false;
    },

    async getImagesForFolder(folder) {
      try {
        // ✅ folosește meta (thumb/full)
        const res = await fetch(`/api/gallery/${folder}/meta`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const items = await res.json();

        // items = [{ thumb: "/uploads/.../thumb/..", full: "/uploads/.../full/.." }, ...]
        const urls = (Array.isArray(items) ? items : [])
          .map((x) => {
            const p =
              typeof x === "string" ? x : (x && (x.thumb || x.full)) || "";

            if (!p) return "";
            return p.startsWith("http")
              ? p
              : new URL(p, window.location.origin).toString();
          })
          .filter(Boolean);

        // fallback dacă nu există poze
        return urls.length
          ? urls
          : [new URL(fallbackImg, window.location.origin).toString()];
      } catch (err) {
        console.error("❌ Eroare la încărcarea imaginilor pentru", folder, err);
        return [new URL(fallbackImg, window.location.origin).toString()];
      }
    },

    // 🔁 Schimbă imaginea activă periodic
    startImageRotation() {
      this.intervalId = setInterval(() => {
        this.servicii.forEach((s) => {
          if (s.imagini && s.imagini.length > 1) {
            s.currentIndex = (s.currentIndex + 1) % s.imagini.length;
            s.nextImage = s.imagini[s.currentIndex];

            // 🔄 efect de fade simplu
            s.isFading = true;
            setTimeout(() => {
              s.imagine = s.nextImage;
              s.isFading = false;
            }, 800); // durata efectului fade
          }
        });
      }, 30 * 1000); // 30 secunde (pentru test)
      // pentru producție -> înlocuiește cu 5 * 60 * 1000
    },
  },

  async created() {
    const serviciiList = [
      {
        titlu: "Detailing",
        descriere:
          "Curățare în profunzime, protecție și recondiționare completă a interiorului și exteriorului.",
        folder: "detailing",
        link: "/detailing",
      },
      {
        titlu: "Polish",
        descriere:
          "Corectare lac, îndepărtare zgârieturi fine și redare luciu profesional caroseriei.",
        folder: "polish",
        link: "/polish",
      },

      /*{
        titlu: "Folii Solare",
        descriere:
          "Folie solară profesională pentru protecție UV, intimitate și un look sportiv.",
        folder: "foliisolare",
        link: "/folii-solare",
      },
      {
        titlu: "Colantare",
        descriere:
          "Schimbă complet culoarea sau stilul mașinii tale cu folii de calitate premium.",
        folder: "colantare",
        link: "/colantare",
      },
      {
        titlu: "PPF",
        descriere:
          "Folie de protecție invizibilă pentru vopsea împotriva zgârieturilor și ciobiturilor.",
        folder: "ppf",
        link: "/ppf",
      }*/ {
        titlu: "Lumini Ambientale",
        descriere:
          "Iluminare LED elegantă și discretă pentru interiorul autoturismului tău.",
        folder: "lumini",
        link: "/lumini-ambientale",
      },
      {
        titlu: "Trape / Panoramice",
        descriere:
          "Întreținere și reparații pentru trape electrice și plafoane panoramice.",
        folder: "panoramic",
        link: "/trape-panoramice",
      },

      /*{
        titlu: "Retapițări",
        descriere:
          "Refacem tapițeria uzată sau deteriorată cu materiale de calitate.",
        folder: "retapitari",
        link: "/retapitari",
      }*/ {
        titlu: "Vopsire Piele",
        descriere:
          "Redăm culoarea originală a scaunelor din piele prin vopsire profesională și tratamente durabile.",
        folder: "vopsirepiele",
        link: "/vopsire-piele",
      },
    ];

    const servicii = [];
    for (const s of serviciiList) {
      const imagini = await this.getImagesForFolder(s.folder);
      servicii.push({
        ...s,
        imagini,
        imagine: imagini[0],
        currentIndex: 0,
        isFading: false,
        nextImage: null,
      });
    }

    this.servicii = servicii;
    this.startImageRotation();
  },

  beforeUnmount() {
    if (this.intervalId) clearInterval(this.intervalId);
  },
};
</script>

<style scoped>
/* 🟡 Efect vizual pentru fade între poze */
.service-bg {
  transition: opacity 0.8s ease-in-out;
  opacity: 1;
}
.service-bg.fading {
  opacity: 0.35;
}
</style>

<style scoped>
@import "@/assets/styles/global.css";

.home-page {
  font-family: Arial, sans-serif;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.9) 0%, #000 100%);
  color: white;
  position: relative;
  z-index: 1;
}

.header-wrapper {
  position: relative;
}

.header-bg {
  background: url("@/assets/background2.png") no-repeat center center;
  background-size: cover;
  height: 90vh;
}

.header-overlay {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 55vh;
  text-align: center;
  color: white;
  pointer-events: none;
}

.cta-btn {
  background-color: white;
  color: black;
  text-decoration: none;
  padding: 1rem 2rem;
  border-radius: 5px;
  font-weight: bold;
  transition: background-color 0.3s;
  pointer-events: auto;
}

.cta-btn:hover {
  background-color: goldenrod;
}

.about-home {
  background: white;
  color: #111;
  padding: 4rem 1rem;
  text-align: center;
}

.about-container {
  max-width: 800px;
  margin: auto;
}

.about-home h2 {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.about-home h2 span {
  color: goldenrod;
  font-weight: bold;
}

.about-home p {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 1.2rem;
}

.btn-about {
  background: black;
  color: white;
  padding: 1rem 2rem;
  border-radius: 4px;
  font-weight: bold;
  text-decoration: none;
  display: inline-block;
  margin-top: 1rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s, transform 0.3s;
}

.btn-about:hover {
  background: goldenrod;
  color: black;
  transform: translateY(-2px);
}

.gallery-intro {
  padding: 2rem 1rem;
  text-align: center;
  position: relative;
  z-index: 2;
}

.gallery-intro h2 {
  color: goldenrod;
  margin-bottom: 2rem;
}

.service-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.service-card {
  width: 300px;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.service-card:hover {
  transform: scale(1.03);
}

.service-bg {
  display: block;
  height: 280px;
  background-size: cover;
  background-position: center;
  border-radius: 12px;
  position: relative;
  text-decoration: none;
  color: white;
}

.service-bg .overlay {
  background-color: rgba(0, 0, 0, 0.6);
  height: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  transition: background-color 0.3s ease;
}

.service-bg:hover .overlay {
  background-color: rgba(0, 0, 0, 0.8);
}

.btn-serviciu {
  background-color: goldenrod;
  color: black;
  font-weight: bold;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.85rem;
  text-decoration: none;
  align-self: flex-start;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  transition: background-color 0.3s ease;
}

.btn-serviciu:hover {
  background-color: white;
}

.reviews-section {
  padding: 2rem 1rem;
}

h3 {
  color: white;
}
.overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(218, 165, 32, 0.85), transparent);
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 1.5rem;
  gap: 0.5rem;
  transition: background 0.3s ease;
  z-index: 2;
  border-radius: 12px;
}

.service-card:hover .overlay {
  background: linear-gradient(to top, rgba(0, 0, 0, 0.9), transparent);
}

.overlay h3,
.overlay p {
  text-shadow: 1px 1px 4px black;
  margin: 0;
}

/* === FORMULAR WHATSAPP === */
.whatsapp-form-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
}

.whatsapp-form {
  background: #111;
  color: #fff;
  border-radius: 12px;
  padding: 2rem;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 0 20px rgba(255, 215, 0, 0.2);
}

.whatsapp-form h3 {
  color: #facc15;
  margin-bottom: 1rem;
  text-align: center;
}

.whatsapp-form label {
  display: block;
  margin-bottom: 0.8rem;
}

.whatsapp-form input,
.whatsapp-form textarea {
  width: 100%;
  padding: 0.6rem;
  border-radius: 6px;
  border: 1px solid #333;
  margin-top: 0.2rem;
  background: #222;
  color: #fff;
  font-size: 0.95rem;
}

.whatsapp-form textarea {
  height: 80px;
  resize: none;
}

.form-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
}

.form-buttons button {
  flex: 1;
  margin: 0 5px;
  padding: 0.6rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
}

.form-buttons button:hover {
  opacity: 0.9;
}

.form-buttons button:first-child {
  background: #25d366;
  color: #fff;
}

.form-buttons .cancel {
  background: #444;
  color: #ccc;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.whatsapp-form-overlay {
  cursor: pointer;
}
.whatsapp-form {
  cursor: default;
}
/* 🔧 Fix: permite click-uri în interiorul formularului WhatsApp */
.header-overlay * {
  pointer-events: auto !important;
}
</style>
